function ContactForm(settings){
	this.className = "ContactForm";

	this.name = "contact";

	if(!settings) settings = {};

	settings = {
		template: ("template" in settings) ? settings.template : "form",
        recaptcha: settings?.recaptcha || false,
	};

	this.data = {
		pages: [
			{
				title: "",
				name: settings.template,
				errors: {
					general: "Please complete all required fields before continuing."
				},
				submissionUrl: "/forms/contact/submitForm/",
			},
			{
				title: "Thanks",
				name: "complete"
			},
		]
	}

	this.setup(settings);
};
ContactForm.inheritsFrom( PageForm );

